// extracted by mini-css-extract-plugin
export default {"pageContainer":"ChatPage_pageContainer__bIGSq","chatContainer":"ChatPage_chatContainer__Wz5Wi","messages":"ChatPage_messages__VrUek"};